<span class="text-2xl font-semibold inline-block py-1 px-2 uppercase rounded uppercase last:mr-0 mr-1"
  [class.text-red-600]="type === 'error'"
  [class.bg-red-200]="type === 'error'"
  [class.text-green-600]="type === 'success'"
  [class.bg-green-200]="type === 'success'"
>
  {{ text }}
</span>
